import CoingeckoIcon from './CoingeckoIcon'

export default CoingeckoIcon
